import * as React from 'react'
import Button from '@doordash/component-button'
import { noop } from 'lodash'
import { OnboardingComponentProps } from '../../molecules/workflow-components'

export const ButtonComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ is_inline, children, ...props }: OnboardingComponentProps) => {
    const onClick = e => {
      e.stopPropagation()
      if (props.trackButtonClick) {
        props.trackWorkflowEvent({
          event: props.eventInfo.event,
          action: props.eventInfo.action,
          name: props.eventInfo.name,
        })
      }
    }
    return (
      <Button isInline={is_inline} {...props} onClick={props.enableClickEvent? onClick: noop}>
        {children}
      </Button>
    )
  }
)
